import { defineMessages } from 'react-intl'

export default defineMessages({
  'first': {
    id: 'users.first',
    defaultMessage: 'First name cannot be empty',
  },
  'last': {
    id: 'users.last',
    defaultMessage: 'Last name cannot be empty',
  },
  'username': {
    id: 'users.username',
    defaultMessage: 'A user with this username already exists',
  },
  'email': {
    id: 'users.email',
    defaultMessage: 'Please input a valid email',
  },
  'thisFieldIsRequired': {
    id: 'users.thisFieldIsRequired',
    defaultMessage: 'Username cannot be empty',
  },
  'postal_code': {
    id: 'users.postal_code',
    defaultMessage: 'Zip codes are 5 or 9 digits long',
  },
})
